import { Injectable } from '@angular/core';
import { Either, Right } from 'purify-ts';
import { PhoneNumbersRepositoryFailure } from '../../domain/phone-numbers/failure';
import { IPhoneNumbersRepository } from '../../domain/phone-numbers/i-phone-numbers-repository';
import { CompanyPhoneNumber } from '../../domain/phone-numbers/types';
import { fakePhoneNumbers } from './data';

@Injectable({
  providedIn: 'root',
})
export class FakePhoneNumbersRepository implements IPhoneNumbersRepository {
  public async getList(): Promise<Either<PhoneNumbersRepositoryFailure, CompanyPhoneNumber[]>> {
    return Right(fakePhoneNumbers);
  }
}
